import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { InstallationAction } from '../../actions';
import { AlertAction } from '../../actions/AlertAction';
import { store } from '../../store';
import InstallationStep0 from './InstallationStep0';
import InstallationStep1 from './InstallationStep1';
import InstallationStep2 from './InstallationStep2';
import InstallationStep3 from './InstallationStep3';
import InstallationStep4 from './InstallationStep4';
import InstallationStep5 from './InstallationStep5';
import InstallationStep6 from './InstallationStep6';

import { ExportPdfReport } from '../../components/common/ExportPdfReport';
import { RaySignaturePad } from '../common';
import AccordionSection from '../common/AccordionSection';

import axios from 'axios';
import { Translate as t } from '../../config/Translate';

const InstallationStep7 = ({ info, Update, product, isSummary = false, view, SendInstallationMail, gostep }) => {

	// const [t] = useTranslation();
	const [isChecked, setIsChecked] = useState(false);
	const [showTab, setShowTab] = useState({
		tab1: true,
		tab2: false,
		tab3: false,
		tab4: false,
		tab5: false,
		tab6: false,
		tab7: false,
		tab8: false
	});

	const Prev = (e) => {
		Update(info._id, { installationStep: 7 });
	};

	// 상단 배지·◀ 이동: 이 단계에는 저장할 입력이 없다(서명은 즉시 업로드, 개인정보 동의 체크는 저장 대상 아님) → 목표 단계만 저장.
	useEffect(() => {
		if (gostep && gostep.curStep == 8) {
			Update(info._id, { installationStep: gostep.goStepNo });
		}
	}, [gostep]);


	const iubendaUpdate = () => {

		const datas = {
			subject: {
				first_name: info?.customerSignatureName,
				verified: true
			},
			preferences: { "privacy_policy": true },
			legal_notices: [
				{ "identifier": "privacy_policy" },
				{ "identifier": "cookie_policy" },
				{ "identifire": "terms", "version": "v1" }
			],
			proofs: [{ "content": "proof_content", "form": "proof_form" }]
		};

		try {
			axios.post('https://consent.iubenda.com/consent/', datas, {
				headers: {
					'Content-Type': 'application/json',
					'ApiKey': 'eGYsdYTiYWsCsxduymtBvvR91dM1MORg',
					'Accept': 'application/json',
				}
			})
				.then(function (response) {
					Update(info._id, { isSubmit: true, isIubendaId: response.data.subject_id });
				})
				.catch(function (error) {
				});
		} catch (err) {
			console.log(err);
		}
	}


	function validNext(e) {
		//////SendInstallationMail(info.id, info, 'installComplete');
		e.preventDefault();
		if (isChecked) {
			iubendaUpdate();
		} else {
			store.dispatch(AlertAction.ErrorMsg(t('auth.message.privacyAlert')));
		}
	};

	function handleChangeData(e) {
		console.log(e.target);
		const { name, checked } = e.target;
		if (checked) {
			setIsChecked(true);
		} else {
			setIsChecked(false);
		}
	}

	const sigInstaller = () => {
	};

	const sigCustomer = () => {
	};

	return (
		<>
			{(info.isSubmit && view != "view") && <>
				<div className="section text-center mt-2 mb-2">
					<div className="card">
						<div className="card-body">
							<div className="listed-detail p-4">
								<div className="icon-wrapper">
									<div className="iconbox bg-success">
										<ion-icon name="checkmark-sharp" role="img" className="md hydrated" aria-label="checkmark sharp"></ion-icon>
									</div>
								</div>
								<h2 className="mt-2">{t('installation.message.success.installationReportCompleted')}</h2>
							</div>
						</div>
					</div>
				</div>
				<div className="section">
					<div>
						<Link to="/Calendar" className="btn btn-block btn-primary btn-lg">{t('installation.calendar.title')}</Link>
						<Link to="/" className="btn btn-block btn-outline-primary btn-lg">{t('nav.home')}</Link>
					</div>
				</div>
			</>}
			{(!info.isSubmit || (info.isSubmit && view == "view")) &&
				<>
					<div className="section mt-1">
						<div className="section-title">{t('installation.label.summarySig')}</div>
					</div>
					<div className="section">
						<AccordionSection isOpen={showTab.tab1} onToggle={() => setShowTab({ ...showTab, tab1: !showTab.tab1 })} title={t('site.label.siteInfo')}>
							<InstallationStep1 info={info} isSummary={true} product={product} />
						</AccordionSection>
						<AccordionSection isOpen={showTab.tab2} onToggle={() => setShowTab({ ...showTab, tab2: !showTab.tab2 })} title={t('product.label.productInfo')}>
							<InstallationStep0 info={info} isSummary={true} product={product} />
						</AccordionSection>
						<AccordionSection isOpen={showTab.tab3} onToggle={() => setShowTab({ ...showTab, tab3: !showTab.tab3 })} title={t('installation.label.packagingCheck')}>
							<InstallationStep2 info={info} isSummary={true} product={product} />
						</AccordionSection>
						<AccordionSection isOpen={showTab.tab4} onToggle={() => setShowTab({ ...showTab, tab4: !showTab.tab4 })} title={t('product.label.systemConfig')}>
							<InstallationStep3 info={info} isSummary={true} product={product} />
						</AccordionSection>
						<AccordionSection isOpen={showTab.tab5} onToggle={() => setShowTab({ ...showTab, tab5: !showTab.tab5 })} title={t('product.label.imageQuality')}>
							<InstallationStep4 info={info} isSummary={true} product={product} />
						</AccordionSection>
						<AccordionSection isOpen={showTab.tab6} onToggle={() => setShowTab({ ...showTab, tab6: !showTab.tab6 })} title={t('installation.label.regulatoryDocument')}>
							<InstallationStep5 info={info} isSummary={true} product={product} />
						</AccordionSection>
						<AccordionSection isOpen={showTab.tab7} onToggle={() => setShowTab({ ...showTab, tab7: !showTab.tab7 })} title={t('installation.label.userTraining')}>
							<InstallationStep6 info={info} isSummary={true} product={product} />
						</AccordionSection>
						{view == "view" &&
							<AccordionSection isOpen={showTab.tab8} onToggle={() => setShowTab({ ...showTab, tab8: !showTab.tab8 })} title={t('common.field.signature')}>
								<RaySignaturePad sigType="Installer" reportId={info._id} sigPath={info} view="view" />
								<RaySignaturePad sigType="Customer" reportId={info._id} sigPath={info} view="view" />
							</AccordionSection>
						}
					</div>
					{view == "view" &&
						<div className="section">
							<div className="mb-3 mt-2 ms-2 me-2">
								<ExportPdfReport reportType={'installation'} infos={info} />
								<button className="btn btn-outline-primary btn-block btn-lg" onClick={() => history.back()}>{t('common.button.close')}</button>
							</div>
						</div>
					}
					{view != "view" &&
						<>
							<div className="section mb-2">
								<div style={{ backgroundColor: "white" }}>
									<RaySignaturePad sigType="Installer" reportId={info._id} sigPath={info} />
									<RaySignaturePad sigType="Customer" reportId={info._id} sigPath={info} />
								</div>
								<div className="section mb-2">
									<input type="checkbox"
										checked={isChecked}
										onChange={handleChangeData} />
									{t('auth.message.privacyConfirm1')}
									<label className="form-check-label">
										<a href="https://www.iubenda.com/privacy-policy/74962298/legal" className="iubenda-nostyle iubenda-embed " title="Privacy Policy ">&nbsp; Privacy Policy &nbsp;</a><script type="text/javascript" src="https://cdn.iubenda.com/iubenda.js"></script>
									</label>
									{t('auth.message.privacyConfirm2')}
								</div>
								<button className="btn btn-block btn-primary btn-lg" onClick={validNext}>{t('common.button.complete')}</button>
								<button className="btn btn-block btn-outline-primary btn-lg" onClick={() => Prev()}>{t('common.button.back')}</button>
							</div>
						</>
					}
				</>}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
	SendInstallationMail: (_id, data, subType) => dispatch(InstallationAction.SendInstallationMail(_id, data, subType))
});

export default connect(null, mapDispatch)(InstallationStep7);
